import { CampaignsService } from './../campaigns.service';
import { Component, OnInit, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CreateCampaignComponent } from '../create-campaign/create-campaign.component';
import { ActivatedRoute } from '@angular/router';
import { Observable, map, startWith, switchMap, tap } from 'rxjs';
import { Campaign } from '../../_shared/models/campaign.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-campaign-list',
  templateUrl: './campaign-list.component.html',
  styleUrls: ['./campaign-list.component.scss'],
})
export class CampaignListComponent {
  private activatedRoute = inject(ActivatedRoute);
  private modalController = inject(ModalController);
  private campaignsService = inject(CampaignsService);

  filter = new FormGroup<any>({
    team: new FormControl(null, Validators.required),
    // title: new FormControl(null, Validators.required),
    // description: new FormControl(null, Validators.required),
  })

  campaings$: Observable<Campaign[]> = this.activatedRoute.parent.parent.paramMap.pipe(
    map(params => params.get('id')),
    tap(team => this.filter.controls.team.setValue(team)),
    switchMap(() => this.campaignsService.index(this.filter.value))
  )

  constructor() { }

  async createCampaign() {
    const modal = await this.modalController.create({
      component: CreateCampaignComponent,
      componentProps: { team: this.activatedRoute.parent.snapshot.parent.params.id }
    });
  
    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
      //console.log(data);
    }
  }

}
